export default function RegulaminPageEn() {
  return (
    <section className="section" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h2>Terms & Conditions</h2>

      <p><b>Art Rafał Tołczyk</b><br />
      ul. Boya-Żeleńskiego 2, 15-198 Białystok<br />
      NIP: 9661263250<br />
      Email: kontakt@arttolczyk.pl</p>

      <h3>1. General Information</h3>
      <p>
        These Terms govern the use of this online shop. By placing an order, the
        Customer accepts all conditions stated below.
      </p>

      <h3>2. Products</h3>
      <p>
        All artworks are handmade. Some products are ready for shipment within
        1–3 working days. Products marked as “made to order” require up to
        10 working days for preparation.
      </p>

      <h3>3. Prices</h3>
      <p>
        All prices include VAT. Shipping within Poland is free. International
        shipping is available worldwide.
      </p>

      <h3>4. Orders</h3>
      <p>
        Orders are placed by completing the checkout form and selecting a
        preferred payment method.
      </p>

      <h3>5. Payment Methods</h3>
      <ul>
        <li>Online payment (Przelewy24 / PayU)</li>
        <li>Traditional bank transfer</li>
      </ul>

      <h3>6. Shipping</h3>
      <p>
        Orders are shipped after payment is confirmed. Delivery time depends on
        the destination country.
      </p>

      <h3>7. Returns</h3>
      <p>
        Ready-made artworks may be returned within 14 days in their original
        condition. Handmade items created on request cannot be returned unless
        they arrive damaged.
      </p>

      <h3>8. Complaints</h3>
      <p>
        Reports of damaged shipments should be sent to: kontakt@arttolczyk.pl.
        Each case is handled individually.
      </p>

      <h3>9. Personal Data</h3>
      <p>
        Personal data is processed exclusively for order handling, according to
        the Privacy Policy.
      </p>

      <h3>10. Final Provisions</h3>
      <p>
        The shop reserves the right to update these Terms at any time.
      </p>
    </section>
  );
}

